import React, { useRef, useEffect, useState } from "react";

interface AccordionSectionProps {
  isOpen: boolean;
  onHeaderClick?: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({ isOpen, onHeaderClick, header, children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState("0px");

  useEffect(() => {
    const node = contentRef.current;
    if (!node) return;

    const updateHeight = () => {
      if (isOpen) {
        setMaxHeight(`${node.scrollHeight}px`);
      } else {
        setMaxHeight("0px");
      }
    };

    updateHeight();
    const observer = new ResizeObserver(() => {
      if (isOpen) {
        setMaxHeight(`${node.scrollHeight}px`);
      }
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [isOpen, children]);

  const wrapperStyle: React.CSSProperties = {
    //overflow: "hidden",
    transition: "max-height 0.4s ease, opacity 0.4s ease, transform 0.3s ease",
    maxHeight: maxHeight,
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? "translateY(0)" : "translateY(-10px)",
  };

  const sectionStyle: React.CSSProperties = {
    marginBottom: "20px",
  };

  const headerStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 8px",
    color: "#000000de",
    fontFamily: "Avenir Next Codensed Ultralight",
    cursor: "pointer",
  };

  return (
    <div style={sectionStyle} onClick={onHeaderClick}>
      <div style={headerStyle}>{header}</div>
      <div style={wrapperStyle}>
        <div ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionSection;